import { Helmet } from 'react-helmet-async';
import { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
// @mui
import { Alert, Container, Stack, Select, Button, ToggleButtonGroup, ToggleButton, Typography, FormControl, InputLabel, MenuItem, Grid } from '@mui/material';
import api from 'src/utils/api';
import profile from '../../store/profile';
// components
import { ProductList } from '../../sections/@dashboard/products';
import IntensiveList from '../../sections/@dashboard/products/IntensiveList';
import Iconify from '../../components/iconify';

// ----------------------------------------------------------------------

export default function ProductsPage() {
  const location = useLocation();
  const navigate = useNavigate();

  const [courses, setCourses] = useState([]);
  const [courseId, setCourseId] = useState(false);
  const [isGuest, setIsGuest] = useState(Number(profile.data?.is_guest) === 1);
  const [tab, setTab] = useState(1);

  const [lessons, setLessons] = useState([]);

  useEffect(() => {
    api.get('course-api')
      .then((result) => {
        setCourses(result);
        // If teacher is a guest (from profile), use the provided course_id and prevent changing it
        if (Number(profile.data?.is_guest) === 1) {
          setIsGuest(true);
          if (profile.data?.course_id) setCourseId(profile.data.course_id);
        } else if (location.state && location.state.id) {
          // fallback: if a specific course id was passed via navigation state
          setCourseId(location.state.id);
        } else if (result && result.length > 0) {
          setCourseId(result[0].id);
        }
      })
      .catch(() => {
        setCourses([]);
      });
  }, [location.state]);

  useEffect(() => {
    if (courseId)
      api.get(`lesson-api?sort=name&filter[edmap]=${tab}&filter[course_id]=${courseId}&per-page=100`)
        .then((result) => {
          setLessons(result);
        })
        .catch(() => {
          setLessons([]);
        });
  }, [tab, courseId])

  return (
    <>
      <Helmet>
        <title> Уроки | Lala English </title>
      </Helmet>

      <Alert severity="error" sx={{ mb: 5, pl: 3 }}>Тут ви можете переглядати інформацію про уроки ваших курсів.</Alert>
      <Container>

        {location.state && location.state.id ? <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Button onClick={() => navigate(-1)} variant="outlined" startIcon={<Iconify icon="eva:arrow-back-fill" />}>
            Назад
          </Button>
        </Stack> : null}

        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">Курс</InputLabel>
            <Select
              // Виправлено: courseId - це число або false, у нього немає .length
              // Використовуємо перевірку на істинність або порожній рядок
              value={courseId || ''}
              label="Курс"
              onChange={(event) => setCourseId(event.target.value)}
              disabled={isGuest}
            >
              {courses.map((value) => <MenuItem key={value.id} value={value.id}>{value.name} {value.level?'Classic':'Base'}</MenuItem>)}
            </Select>
          </FormControl>
        </Stack>

        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <ToggleButtonGroup
            value={tab}
            exclusive
            onChange={(_, value) => setTab(value)}
          >
            <ToggleButton value={1}>
              <Typography>Ed Map 1</Typography>
            </ToggleButton>
            <ToggleButton value={2}>
              <Typography>Ed Map 2</Typography>
            </ToggleButton>
            <ToggleButton value={3}>
              <Typography>Ed Map 3</Typography>
            </ToggleButton>
            <ToggleButton value={4}>
              <Typography>Ed Map 4</Typography>
            </ToggleButton>
            <ToggleButton value={5}>
              <Typography>Ed Map 5</Typography>
            </ToggleButton>
          </ToggleButtonGroup>
        </Stack>

        {/* Render two columns: left - products (level < 2), right - intensives (level === 2) */}
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            {/* Show lessons whose `level` is less than 2 (coerce to Number safely) */}
            <ProductList products={lessons.filter(l => Number(l?.level || 0) < 2)} />
          </Grid>
          <Grid item xs={12} md={6}>
            {/* Show lessons whose `level` equals 2 */}
            <IntensiveList intensives={lessons.filter(l => Number(l?.level || 0) === 2)} />
          </Grid>
        </Grid>
      </Container>
    </>
  );
}